import { DEFAULT_BILLING_CYCLE, QUERY_PARAM_FOR_BILLING_CYCLE, BILLING_CYCLE } from 'config/constants';

const BILLING_CYCLE_AND_QUERY_PARAMS_GROUPED = [
  {
    billing_cycle: BILLING_CYCLE.MONTHLY_4_SINGLE,
    query_param: QUERY_PARAM_FOR_BILLING_CYCLE.$4_MONTH
  },
  {
    billing_cycle: BILLING_CYCLE.MONTHLY_8_SINGLE,
    query_param: QUERY_PARAM_FOR_BILLING_CYCLE.$8_MONTH
  },
  {
    billing_cycle: BILLING_CYCLE.MONTHLY_15_SINGLE,
    query_param: QUERY_PARAM_FOR_BILLING_CYCLE.$15_MONTH
  },
  {
    billing_cycle: BILLING_CYCLE.MONTHLY_4_ANNUAL,
    query_param: QUERY_PARAM_FOR_BILLING_CYCLE.$4_ANNNUAL
  },
  {
    billing_cycle: BILLING_CYCLE.MONTHLY_8_ANNUAL,
    query_param: QUERY_PARAM_FOR_BILLING_CYCLE.$8_ANNNUAL
  },
  {
    billing_cycle: BILLING_CYCLE.MONTHLY_15_ANNUAL,
    query_param: QUERY_PARAM_FOR_BILLING_CYCLE.$15_ANNNUAL
  },
];

export function billingCycleQuery(billingCycle) {
  const billingAndQueryGroup = BILLING_CYCLE_AND_QUERY_PARAMS_GROUPED.find(billingGroup => {
    return billingGroup.billing_cycle === billingCycle;
  });
  if (billingAndQueryGroup) {
    return billingAndQueryGroup.query_param;
  }
  return null;
}

export function planPartsFromQuery(query) {
  let billingCycle = DEFAULT_BILLING_CYCLE;
  const { plan } = query;
  if (plan) {
    const billingAndQueryGroup = BILLING_CYCLE_AND_QUERY_PARAMS_GROUPED.find(billingGroup => {
      return billingGroup.query_param === plan;
    });
    if (billingAndQueryGroup) {
      billingCycle = billingAndQueryGroup.billing_cycle;
    }
  }
  return { billingCycle };
}



// WEBPACK FOOTER //
// ./src/utils/planQueryString.js